import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import MountCustom from '../MountCustom'; 
import TestimonialCarousel from '../Testimonials/TestimonialCarousel';

const HookB = () => {
  const [action, setAction] = useState("Document Preparation"); 
  const navigate = useNavigate(); 
  const handleHomeClick = () => {
    navigate('/home'); 
  };

  const handleDocumentPreparationClick = () => {
    setAction("Document Preparation"); 
  };

  const handleConfidenceClick = () => {
    setAction("Confidence"); 
  };

  const isPrerendering = typeof window === 'undefined' || window.__PRERENDERING;
  if (typeof window === 'undefined' || isPrerendering) {
    return isPrerendering ? <div id="prerender-placeholder"></div> : null;
  }


  

  return (
    <div className="setter">
      <Helmet>
        <title>{action === "Document Preparation" ? "Client Advocate" : "Reserch Specialist"} - Contranorm Media & Production</title>
      </Helmet>
      <div className="background-avatar-cow">
       
      </div>
      <MountCustom>
        <div className="page">
          <h1>
            <div className="redRock">{action === "Document Preparation" ? "Client Advocate" : "Project Manager"}</div>
          </h1>
          <h3>{action === "Document Preparation" ? "Unleash Your Potential" : "Envision a Whole New Reality"}
          </h3>
          <div className="underline"></div>
          

          {action === "Document Preparation" ? (
           <>
           <p>
              You don’t need a high school diploma or GED to take college courses or pursue federal employment in the United States. No diploma; no legal experience? We'll help you navigate federal funding, F-1 visas, and administrative hearings. 
            </p>

           </>
                
     
          ) : (
           
            <>
              <p>
                Start your project by choosing a document type. We'll review your supporting documentation and take it from there. When we're done, you'll get a document ready for submission. Need a consult? No problem, select additional services before checkout.
              </p>

            </>
            
           
          )}
          <TestimonialCarousel display="hookB"/>

          <div className="submit-container">
            {action === "Document Preparation" ? (
              <>
                <Link to="/price-calculator" className="submit gray">Get Started</Link>
                <div className="submit" onClick={handleConfidenceClick}>Learn More</div> 
              </>
            ) : (
              <>
                <Link to="/price-calculator" className="submit gray">Get Started</Link>
                <Link to="/hookc" className="submit">Explore</Link> 
              </>
            )}
          </div>
        </div>
      </MountCustom>
    </div>
  );
};

export default HookB;
